/**
 * @author lyh
 * @description 课堂助手-直播课堂、远程评估查看
 * @Date 2023/01/31
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateConfig, templateConfig} from './columns'
import ClassStudentAideInfo from './../classStudentAide/classStudentAideInfo'
import {modelUtils} from '@/utils'
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {classStudentContentExcelColumns} from '../../excelColumns';
import moment from "moment";

let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport, WizCard, WizTabs, WizSpin, WizModal} = component_tool;
let {Session} = utils_tool;
const getClassAideEntityInfo = (history) => {
  let record = {}
  if (history.location) {
    if (history.location && history.location.record) {
      record = history.location.record;
      Session.set('classAideEntityInfo', record)
    } else {
      record = Session.get('classAideEntityInfo') || 0
    }
  } else {
    record = Session.get('classAideEntityInfo') || 0
  }
  return record
}

const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY.MM.DD HH.mm.ss') : '';
}
class ClassStudentContentList extends WizContainer {
  componentName = 'classStudentContentList';
  constructor(props) {
    super(props);
    this.state = {
      selectedClassResultRows: [],//选择的学员
      classStudentExamInfo:{}
    };
    this.classAideEntityInfo = getClassAideEntityInfo(props.history);
  }

  propsAndStateOnChange = {

  };

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key];
    let columns = classStudentContentExcelColumns;
    if (o['success']) {
      let data = o['data'];
      data && data.length && data.forEach(element => {
        if(element.mobile !== ''&& element.mobile !== null && element.mobile !== undefined) {
            element.mobile=element.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
          }
      });
      let _data = [];
      //对需要转换的信息进行转换，如枚举
      data && data.forEach(d => {
        let _d = { ...d };
        _d.jobState = d.jobState ===1 ? "在职" : d.jobState ===0 ?  "离职" : "";
        _d.leaveState = d.leaveState ===1 ? "是" : d.leaveState ===0 ?  "否" : "";
        _d.operationType = d.operationType ===1 ? "阅读" : d.pass ===0 ?  "下载" : "";
        _d.operationTime = d.operationTime ? formatterDateTime(d.operationTime) : "";
        _data.push(_d);
      });
      WizBrowserExport({
        title: '资讯记录',
        sheetName: '资讯记录',
        columns: columns.filter((_, index) => index),
        rows: _data,
        filename: '资讯记录.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _list(nextProps, nextState, key) {
    let o = nextProps[key] || {}
    let {code, success, msg, data} = o
    if (success) {
      let list = data.records;
      let listNew = []
      list && list.length && list.forEach(element => {
        if(element.mobile !== ''&& element.mobile !== null && element.mobile !== undefined) {
            element.mobile=element.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
          }
        listNew.push(element);
    });
    return listNew;
    } else {
      wizNotice.error(msg)
      return false;
    }
  };

  _render() {
    const {classStudentManagementLoading} = this.props;
    let record = this.classAideEntityInfo;
    let classInfoId = null;
    let entityId = null;
    let classAideId = null;
    let aideTypeName = null;
    let aideTypeId = null;
    if (record) {
      classInfoId = record.classId;
      entityId = record.id;
      classAideId = record.classAideId;
      aideTypeId = record.aideTypeId;
      aideTypeName = record.aideTypeName;
    }
    let _templateConfig = templateConfig({
      onSelect: (keys, rows) => {
        this.setState({
          selectedClassResultRows: rows,
          selectedRows: rows.length,
          data: new Date().getTime(),
          rows: rows
        });
      },
      _this: this,
      classInfoId,
      aideTypeName,
      entityId,
      aideTypeId,
      classAideId,
    });
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      classInfoId,
      aideTypeId,
      entityId,
      classAideId,
      aideTypeName,
      apiDataFormat: {
        export: this._handleFile,
        list: this._list,
      },
    });

    return (
      <>
        <WizSpin tip={"加载中"} spinning={classStudentManagementLoading }>
          <ClassStudentAideInfo {...record} />
          <WizCard title={'环节记录'}>
            <WizReduxTemplate  {..._reduxTemplateConfig} />
          </WizCard>
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {classStudentManagement} = state;
  const load = modelUtils.getLoadingState(state, ['classStudentManagement']);
  return {
    ...load
  }
};

export default connect(mapStateToProps)(ClassStudentContentList);
